import React, { useState } from 'react';
import { auth } from '../firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { playSound, SOUNDS } from '../utils/audio';
import './Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await sendPasswordResetEmail(auth, email);
      playSound(SOUNDS.SUCCESS);
      setMessage('Password reset email sent! Please check your inbox.');
      setError('');
    } catch (resetError) {
      setError('Error sending password reset email. Please try again.');
      setMessage('');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-content">
          <h2>Reset Password</h2>
          {error && <p className="error">{error}</p>}
          {message && <p className="success">{message}</p>}
          <form onSubmit={handleSubmit} className="auth-form">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
            <button type="submit" onClick={() => playSound(SOUNDS.TAP)}>Send Reset Link</button>
            <button
              type="button"
              className="back-to-login"
              onClick={() => {
                playSound(SOUNDS.TAP);
                navigate('/auth');
              }}
            >
              Back to Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword; 